/** Builds a CSV file client-side from headers + rows and triggers a browser download. */
export function exportToCsv(filename: string, headers: string[], rows: (string | number)[][]): void {
    const csvContent = [
        headers.join(','),
        ...rows.map(row => row.map(value => `"${String(value).replace(/"/g, '""')}"`).join(',')),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
